import React from 'react';
import classnames from 'classnames';

import { useCartProductAvailability } from 'hooks/useCartProductAvailability';

import styles from './CartProductStock.module.scss';

export default function CartProductStock({
  stock,
}: {
  stock: string;
}): JSX.Element {
  const { isInStock, stockString } = useCartProductAvailability(stock);

  return (
    <span
      className={classnames(styles.stock, {
        [styles.unavailable]: !isInStock,
      })}
    >
      {stockString}
    </span>
  );
}
